// extracted by mini-css-extract-plugin
module.exports = {"headerWrapper":"Header_headerWrapper__ctXJk","title":"Header_title__2cIru","form":"Header_form__1fvt6"};